import { render } from "./EditGuestPage.vue?vue&type=template&id=79f45fc0"
import script from "./EditGuestPage.vue?vue&type=script&lang=js"
export * from "./EditGuestPage.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__